/* eslint-disable no-console */
import { put, takeLatest, all, select } from 'redux-saga/effects';
import { isObjectEqual } from '~/helpers/functions';
import { InternalDimensionActionTypes } from '~/store/ducks/InternalDimension/types';
import { storeInternalDimensionIntoRoom } from '~/store/ducks/Room/actions';
import { getRoomState } from '~/store/ducks/Room/selectors';
import { RoomState } from '~/store/ducks/Room/types';

export function* checkInternalDimensionState(action: any): any {
  const roomState: RoomState = yield select(getRoomState);
  const { length, width, height } = roomState.data;
  const internalDimensionState = { length, width, height };
  const isEquals = isObjectEqual(internalDimensionState, action.payload.data);

  if (!isEquals) {
    yield put(storeInternalDimensionIntoRoom(action.payload.data));
  }
}

export default all([takeLatest([InternalDimensionActionTypes.STORE_DATA], checkInternalDimensionState)]);
